import React from "react";

export function CreateDash({ onCreateDash, onCreateScenes }) {
  return (
    <div className={`bsy-create-form  `}>
      <div class="bsy-excel-form-item bsy-form-blank" onClick={onCreateDash}>
        <div
          class="blank-item blank-report"
          style={{
            background:
              "url(/template/formreport/static/css/resources/images/blank-report.png)",
          }}
        ></div>
        <div class="form-label">
          {React.language("create.dash.report")}
        </div>
      </div>
      <div class="bsy-excel-form-item right" onClick={onCreateScenes}>
        <div
          class="blank-item blank-scenes"
          style={{
            background:
              "url(/template/formreport/static/css/resources/images/blank-scenes.png)",
          }}
        ></div>
        <div class="form-label">
          {React.language("create.scenes.report")}
        </div>
      </div>
    </div>
  );
}
